/* eslint-disable no-useless-concat */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../../_metronic/helpers'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import {useTranslation, initReactI18next} from 'react-i18next'
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs'
import 'react-tabs/style/react-tabs.css'
import axios from 'axios'
import {
  getPriceJbp,
  getPriceAll,
  getDetailJbp,
  getPriceJbpSearch,
  getSalesOrgAllMasterData,
  getRegionAllMasterData,
  getFilterCityMasterData,
  getByProduct,
  getPriceAllSearch,
} from '../../../../api/modules/master-data/master_2'
import {getCustomerAll, getCustomerSearch} from '../../../../api/modules/master-data/master'
import Pagination from '../../component/Pagination'
import swal from 'sweetalert'
import {getAccessesPriceJbp} from '../../../../api/modules/access/access'
import CreatableSelect from 'react-select/creatable'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../../_metronic/layout/core'
import {Link, useNavigate} from 'react-router-dom'
import Select from 'react-select'
import {MultiSelect} from 'react-multi-select-component'
import InputGroup from 'react-bootstrap/InputGroup'
import i18next from 'i18next'
import CurrencyInput from 'react-currency-input-field'
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import {Spinner} from 'react-bootstrap'
import CustomUseEffect from './CustomUseEffect'
import {id} from 'date-fns/locale'
import {match} from 'assert'
import {ModalBrowsBasicPrices, ModalBrowseCustomers} from '../../../../components'

type Props = {
  className: string
}

const CreateJbp: React.FC<Props> = ({className}) => {
  const intl = useIntl()
  const navigate = useNavigate()

  const removeStorage = () => {
    localStorage.removeItem('credential')
    localStorage.removeItem('credential-decoded')
    localStorage.removeItem('cust-code')
    sessionStorage.removeItem('id')
    sessionStorage.removeItem('po')
    localStorage.removeItem('token')
    localStorage.removeItem('role-flag')
    localStorage.removeItem('dist')
    localStorage.removeItem('cust-group')
    sessionStorage.removeItem('SI_ID')
    localStorage.removeItem('namaUser')
    localStorage.removeItem('username')
    localStorage.removeItem('name')
    localStorage.removeItem('access')
    localStorage.removeItem('accesses')
    localStorage.removeItem('cust-grup')
    localStorage.removeItem('email')
    sessionStorage.removeItem('kid')
    sessionStorage.removeItem('order-detail-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sip')
    localStorage.removeItem('user-id')
    localStorage.removeItem('token')
    sessionStorage.removeItem('amandemen')
    localStorage.removeItem('cus-grup')
    localStorage.removeItem('idNews')
    sessionStorage.removeItem('jbp')
    sessionStorage.removeItem('jbp-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sales-organization')
  }

  const handleOpen = (e: any) => {
    const icon = e.target
    if (icon.classList.contains('iconArow')) {
      icon?.classList.remove('iconArow')
      icon?.classList.add('iconArowOpen')
    } else {
      icon?.classList.remove('iconArowOpen')
      icon?.classList.add('iconArow')
    }
    const target = e.currentTarget.getAttribute('data-target')
    const fold = document.getElementById(target)
    fold?.classList.toggle('fold-open')
  }

  const [show, setShow] = useState(false)
  const [show1, setShow1] = useState(false)
  const [show2, setShow2] = useState(false)

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  const handleClose1 = () => setShow1(false)
  const handleShow1 = () => setShow1(true)
  const handleClose2 = () => setShow2(false)
  const handleShow2 = () => setShow2(true)

  const {t} = useTranslation()
  const [btnLoading, setBtnLoading] = useState(false)

  const [price, setPrice] = useState<any[]>([])
  const [product, setProduct] = useState<any[]>([])
  const [page, setPage] = useState(0)
  const [per, setPer] = useState(0)
  const [loading, setLoading] = useState(false)
  const [numberURL, setNumberURL] = useState([])
  const [customer, setCustomer] = useState<any>()
  const [sorg, setSorg] = useState<any>()
  const [regions, setRegions] = useState<any[]>([])
  const [regionCreate, setRegionCreate] = useState<any>('')
  const [cities, setCities] = useState<any>([])
  const [numberURLProduct, setNumberURLProduct] = useState([])

  // const getPriceDasar = async () => {
  //   setLoading(true)
  //   console.log('working');
  //   try{
  //     const res = await getPriceAll()
  //     const data = res.data.data
  //     console.log({res});
  //     console.log({data});
  //     setProduct(data.data)
  //     setPage(res.data.data.current_page)
  //     setPer(res.data.data.per_page)
  //     setNumberURLProduct(res.data.data.links)
  //   } catch (err) {
  //     console.log(err);

  //   }

  //   setLoading(false)
  // }
  // const getCustomer = async () => {
  //   setLoading(true)
  //   const res = await getCustomerAll()
  //   setCustomer(res.data.data)
  //   setPage(res.data.data.current_page)
  //   setPer(res.data.data.per_page)
  //   setLoading(false)
  //   setNumberURL(res.data.data.links)
  // }

  useEffect(() => {
    const getSalesOrg = async () => {
      setLoading(true)
      const res = await getSalesOrgAllMasterData()
      const data = res.data.data
      setSorg(data)
      setLoading(false)
    }

    const getRegion = async () => {
      setLoading(true)
      const res = await getRegionAllMasterData()
      const data = res.data.data
      setRegions(data)
      setLoading(false)
    }

    getRegion()
    getSalesOrg()
    // getCustomer()
    // getPriceDasar()
  }, [])

  const [group, setGroup] = useState('')
  const [name, setName] = useState('')
  const [code, setCode] = useState('')

  useEffect(() => {
    const getData = setTimeout(async () => {
      await getCustomerSearch(code, name, group).then((res: any) => {
        setCustomer(res.data.data)
        setNumberURL(res.data.data.links)
      })
    }, 1000)

    return () => clearTimeout(getData)
  }, [code, name, group])

  const paginateNumber = async (number: any) => {
    setLoading(true)
    const res = await axios.get(number, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    })
    const data = res.data.data
    setCustomer(data.data)
    setPage(data.current_page)
    setPer(data.per_page)
    setLoading(false)
    setNumberURL(data.links)
  }

  const [salesOrgCode, setSalesOrgCode] = useState('')
  const [customerCode, setCustomerCode] = useState('')
  const [productCode, setProductCode] = useState('')
  const [regionCode, setRegionCode] = useState<any>([])
  const [cityCode, setCityCode] = useState<any[]>([])
  const [citiCreate, setCitiCreate] = useState<any[]>([])
  const [minimumPrice, setMinimumPrice] = useState<any>(0)
  const [sellingPrice, setSellingPrice] = useState<any>()
  const [discount, setDiscount] = useState('')
  const [purchasePrice, setPurchasePrice] = useState<any>(0)
  const [validFrom, setValidFrom] = useState<any>()
  const [validTo, setValidTo] = useState<any>()
  const [type, setType] = useState('jbp')
  const [isActive, setIsActive] = useState('')
  const [desc, setDesc] = useState('')
  const [isUpload, setIsUpload] = useState(false)

  const handleRegion = async (e: any) => {
    setRegionCode([...e])
    let arr: any = []
    const selectedRegion = [...e].map((item: any) => item.value)
    let getRegionValue = selectedRegion.join(',')
    arr.push(selectedRegion)

    setRegionCreate(arr[0])
    await getFilterCityMasterData(getRegionValue).then((res: any) => {
      const data = res.data.data
      setCities(data)
    })
  }

  const handleProduct = async (e: any) => {
    setProductCode(e)

    if (e !== null) {
      handleClose2()
    }

    await getByProduct(e).then((res: any) => {
      const data = res.data.data
      setMinimumPrice(data?.price)
    })
  }

  const selectedCity = cityCode.map((item: any) => item.value)

  const postPrice = async () => {
    setBtnLoading(true)
    axios
      .post(
        `${
          process.env.REACT_APP_PI_BACKEND_API_MASTERDATA
        }/price-list/jbp/create?credentials=${localStorage.getItem('credential')}`,
        {
          sales_org_code: salesOrgCode,
          customer_code: customerCode,
          product_code: productCode,
          regions: regionCreate,
          cities: selectedCity,
          minimum_price: minimumPrice,
          selling_price: sellingPrice,
          discount: discount,
          purchase_price: Math.round(purchasePrice),
          valid_from: validFrom,
          valid_to: validTo,
          type: 'jbp',
          is_active: isActive,
          description: desc,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
            Accept: 'application/json',
            'Access-Control-Allow-Origin': '*',
          },
        }
      )
      .then((response) => {
        if (!response.data.error) {
          setIsUpload(true)

          handleClose()
          swal({
            title: `${t('Harga JBP Berhasil di Tambahkan')}`,
            icon: 'success',
          }).then(() => {
            if (type == 'jbp') {
              navigate(`/master/price/jbp`)
            } else {
              navigate(`/master/price/non-jbp`)
            }
          })
        }
      })
      .catch((error) => {
        if (error.response.data.message.match('tidak ada price list dasar')) {
          swal({
            title: `${t('kode product tidak ditemukan')}`,
            icon: 'error',
          })
        } else {
          swal({
            title: `${t(error.response.data.message)}`,
            icon: 'error',
          })
        }
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const [editId, setEditId] = useState<any>('')
  const [editSales, setEditSales] = useState<any>('')
  const [editCustomer, setEditCustomer] = useState<any>('')
  const [editProductCode, setEditProductCode] = useState<any>('')
  const [editRegionCode, setEditRegionCode] = useState<any>('')
  const [editCity, setEditCity] = useState<any>('')
  const [editMinPrice, setEditMinPrice] = useState<any>('')
  const [editSellPrice, setEditSellPrice] = useState<any>('')
  const [editDiscount, setEditDiscount] = useState<any>('')
  const [editPurchase, setEditPurchase] = useState<any>('')

  const handleEdit = async (id: any) => {
    handleShow1()
    setEditId(id)

    const res = await getDetailJbp(id)
    const data = res.data.data

    setEditSales(data.sales_org_code)
    setEditCustomer(data.customer_code)
    setEditProductCode(data.product_code)
    setEditRegionCode(data.region_code)
    setEditCity(data.city_code)
    setEditMinPrice(data.minimum_price)
    setEditSellPrice(data.selling_price)
    setEditDiscount(data.discount)
    setEditPurchase(data.purchase_price)
  }

  //#region state for search
  const [salesorg, setSalesorg] = useState('')
  const [custcode, setCustcode] = useState('')
  const [productcode, setProducecode] = useState('')
  const [region, setRegion] = useState('')
  const [city, setCity] = useState('')
  const [minprice, setMinprice] = useState('')
  const [sellprice, setSellprice] = useState('')
  const [dist, setDist] = useState('')
  const [purchaseprice, setPurchaseprice] = useState('')
  //#endregion

  const [disabled, setDisabled] = useState(false)

  const handlePrice = async (e: any) => {
    setDiscount(e)
    const temp = sellingPrice - sellingPrice * (e / 100)
    if (e == '') {
      setPurchasePrice(0)
    } else {
      setPurchasePrice(Number.isNaN(temp) ? 0 : temp)
    }
  }

  const handlePrice2 = async (e: any) => {
    setSellingPrice(e)
    const temp = e - e * (Number(discount) / 100)
    if (discount == '') {
      setPurchasePrice(0)
    } else {
      setPurchasePrice(Number.isNaN(temp) ? 0 : temp)
    }
  }

  // if customerCode != null, then disabled all checkbox
  const handleCustomer = async (e: any) => {
    setCustomerCode(e)
    if (e !== null) {
      handleClose()
    }
  }

  const options = product.map((item: any) => {
    return {value: item.product_code, label: item.product_code.slice(-7)}
  })

  const [language, setLanguage] = useState<any>()
  useEffect(() => {
    const interval = setInterval(() => {
      const getCookie = (name: string) => {
        const value = `; ${document.cookie}`
        const parts = value.split(`; ${name}=`)
        if (parts.length === 2) return parts.pop()?.split('~#~').shift()
      }
      let language = getCookie('i18next')
      setLanguage(language)
    }, 1000)
    return () => clearInterval(interval)
  }, [])

  const paginateNumberProduct = async (number: any) => {
    setLoading(true)
    const res = await axios.get(number, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
    })
    const data = res.data.data
    setProduct(data.data)
    setPage(data.current_page)
    setPer(data.per_page)
    setLoading(false)
    setNumberURLProduct(data.links)
  }

  const [codeSearch, setCodeSearch] = useState('')
  const [nameSearch, setNameSearch] = useState('')
  const [searchprice, setSearchPrice] = useState<any>('')

  useEffect(() => {
    const getData = setTimeout(async () => {
      await getPriceAllSearch(codeSearch, nameSearch, searchprice).then((res: any) => {
        setProduct(res.data.data.data)
        setNumberURLProduct(res.data.data.links)
      })
    }, 1000)

    return () => clearTimeout(getData)
  }, [codeSearch, nameSearch, searchprice])

  CustomUseEffect(() => {
    const product_Code = document.getElementById('product_Code') as HTMLInputElement
    if (product_Code != null) product_Code.value = ''
    const status = document.getElementById('status') as HTMLSelectElement
    if (status != null) status.selectedIndex = 0
    const customer_Code = document.getElementById('customer_Code') as HTMLInputElement
    if (customer_Code != null) customer_Code.value = ''
    const minimum_price = document.getElementById('minimum_price') as HTMLInputElement
    if (minimum_price != null) minimum_price.value = '0'
    const disc = document.getElementById('disc') as HTMLInputElement
    if (disc != null) disc.value = ''
    const purchase_price = document.getElementById('purchase_price') as HTMLInputElement
    if (purchase_price != null) purchase_price.value = '0'
    const dateFrom = document.getElementById('date') as HTMLInputElement
    if (dateFrom != null) dateFrom.value = ''
    const dateTo = document.getElementById('datee') as HTMLInputElement
    if (dateTo != null) dateTo.value = ''
    const desc = document.getElementById('desc') as HTMLInputElement
    if (desc != null) desc.value = ''
    // setRegionCode([])
  }, [salesOrgCode])

  return (
    <>
      {sessionStorage.getItem('jbp') == 'jbp' ? (
        <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: `${t('page harga JBP')}`})}</PageTitle>
      ) : (
        <PageTitle breadcrumbs={[]}>
          {intl.formatMessage({id: `${t('page harga Non JBP')}`})}
        </PageTitle>
      )}
      <div className={`card ${className}`}>
        <div className='card-body mt-5'>
          <div>
            <Row className='mb-4'>
              <Col md={6}>
                <Form.Group controlId='formBasicEmail'>
                  <Form.Label>{t('sub-order-produsen')}</Form.Label>
                  <Form.Select
                    aria-label='Default select example'
                    onChange={(e: any) => {
                      setSalesOrgCode(e.target.value)
                      setRegionCode([])
                      setCityCode([])
                    }}
                  >
                    <option>
                      {t('Choose')} {t('sub-order-produsen')}
                    </option>
                    {sorg?.map((item: any, index: number) => (
                      <option key={item?.code ?? index} value={item?.code}>
                        {item?.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group controlId='formBasicEmail'>
                  <Form.Label>{t('jenis')}</Form.Label>
                  <Form.Control type='text' value='JBP' disabled />
                </Form.Group>
              </Col>
            </Row>

            <Row className='mb-4'>
              <Col md={6}>
                <Form.Group controlId='formBasicEmail'>
                  <Form.Label>Status</Form.Label>
                  <Form.Select
                    aria-label='Default select example'
                    onChange={(e: any) => setIsActive(e.target.value)}
                    id='status'
                  >
                    <option value=''>{t('Choose') + ' ' + 'Status'}</option>
                    <option value='true'>{t('Active')}</option>
                    <option value='false'>{t('Non-Active')}</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group controlId='formBasicEmail'>
                  <Form.Label>{t('Customer Code')}</Form.Label>
                  <div className='d-flex'>
                    <Form.Control
                      id='customer_Code'
                      className='me-1'
                      type='text'
                      placeholder={t('Customer Code')}
                      value={customerCode}
                      disabled
                    />
                    <button className='btn btn-primary' onClick={handleShow}>
                      {t('Browse')}
                    </button>
                  </div>
                </Form.Group>
              </Col>
            </Row>

            <Row className='mb-4'>
              <Col md={6}>
                <Form.Group controlId='formBasicEmail'>
                  <Form.Label>{t('sub-order-wilayah')}</Form.Label>
                  <MultiSelect
                    options={regions.map((item: any) => {
                      return {
                        value: item.id,
                        label: item.value,
                      }
                    })}
                    value={regionCode}
                    onChange={handleRegion}
                    labelledBy='Select'
                  />
                  {/* <Form.Select aria-label="Default select example" onChange={(e: any) => handleRegion(e.target.value)}>
                                        <option value="">{t("Select menu")}</option>
                                        {regions?.map((item: any) => (
                                            <option value={item.id}>{item.value}</option>
                                        ))}
                                    </Form.Select> */}
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group controlId='formBasicEmail'>
                  <Form.Label>{t('sub-order-kota')}</Form.Label>
                  <MultiSelect
                    key={salesOrgCode}
                    options={cities?.map((item: any) => {
                      return {label: item.value, value: item.id}
                    })}
                    value={cityCode}
                    onChange={setCityCode}
                    labelledBy='Select'
                  />
                  {/* <Form.Select aria-label="Default select example" onChange={(e: any) => setCityCode(e.target.value)}>
                                            <option value="">{t("Select menu")}</option>
                                            {cities?.map((item: any) => (
                                                <option value={item.id}>{item.value}</option>
                                            ))}
                                        </Form.Select> */}
                </Form.Group>
              </Col>
            </Row>

            <Row className='mb-4'>
              <Col md={6}>
                <Form.Group controlId='formBasicEmail'>
                  <Form.Label>{t('Product Code')}</Form.Label>
                  <div className='d-flex'>
                    <Form.Control
                      key={salesOrgCode}
                      id='product_Code'
                      size='sm'
                      className='me-1'
                      type='text'
                      placeholder={t('Product Code')}
                      value={productCode.slice(-7)}
                      disabled
                    />
                    <Button size='sm' className='btn btn-primary' onClick={handleShow2}>
                      {t('Browse')}
                    </Button>
                  </div>
                  {/* <Select
                                        isClearable
                                        onChange={opt => handleProduct(opt?.value)}
                                        options={options} /> */}
                  {/* <Form.Select
                                        aria-label='Default select example'
                                        id='code'
                                        onChange={(e: any) => handleProduct(e.target.value)}
                                    >
                                        <option>{t("Choose")} {t('Product Code')}</option>
                                        {product.map((products) => (
                                            <option value={products.product_code}>{products.product_code.slice(-7)}</option>
                                        ))}
                                    </Form.Select> */}
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group controlId='formBasicEmail'>
                  <Form.Label>Minimum {t('Harga')}</Form.Label>
                  {minimumPrice ? (
                    <Form.Control
                      id='minimum_price'
                      size='sm'
                      type='text'
                      placeholder={'Minimum ' + t('Harga')}
                      value={
                        i18next.language === 'en'
                          ? 'Rp' + minimumPrice.toLocaleString('en', {maximumFractionDigits: 4})
                          : 'Rp' + minimumPrice.toLocaleString('id', {maximumFractionDigits: 4})
                      }
                      disabled
                    />
                  ) : (
                    <Form.Control id='minimum_price' size='sm' type='text' value={''} disabled />
                  )}
                </Form.Group>
              </Col>
            </Row>

            <Row className='mb-1'>
              <Col md={6}>
                <Form.Group controlId='formBasicEmail'>
                  <Form.Label>{t('Selling Price')}</Form.Label>
                  <InputGroup className='mb-3' size='sm'>
                    <InputGroup.Text>
                      <span className='px-1'>Rp</span>
                    </InputGroup.Text>
                    <CurrencyInput
                      key={salesOrgCode}
                      className='form-control form-control-sm'
                      placeholder={t('Selling Price')}
                      decimalSeparator={language === 'en' ? '.' : ','}
                      groupSeparator={language === 'en' ? ',' : '.'}
                      onValueChange={(value: any) => {
                        handlePrice2(value)
                      }}
                      decimalsLimit={-1}
                    />
                  </InputGroup>
                  {/* <Form.Control
                                        type='text'
                                        placeholder={t('Selling Price')}
                                        onChange={(e: any) => setSellingPrice(e.target.value)} /> */}
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group controlId='formBasicEmail'>
                  <Form.Label>{t('Discount')}</Form.Label>
                  <InputGroup className='mb-3' size='sm'>
                    <Form.Control
                      id='disc'
                      type='text'
                      placeholder={t('Discount')}
                      onChange={(e: any) => handlePrice(e.target.value)}
                    />
                    <InputGroup.Text>
                      <span className='px-2'>%</span>
                    </InputGroup.Text>
                  </InputGroup>
                </Form.Group>
              </Col>
            </Row>

            <Form.Group className='w-100 mb-4' controlId='formBasicEmail'>
              <Form.Label>{t('Purchase Price')}</Form.Label>
              <Form.Control
                id='purchase_price'
                size='sm'
                type='text'
                placeholder={t('Purchase Price')}
                value={
                  i18next.language === 'en'
                    ? 'Rp' +
                      Math.round(purchasePrice).toLocaleString('en', {maximumFractionDigits: 4})
                    : 'Rp' +
                      Math.round(purchasePrice).toLocaleString('id', {maximumFractionDigits: 4})
                }
                disabled
              />
            </Form.Group>

            <Row className='mb-3'>
              <Col md={6}>
                <Form.Group controlId='formBasicEmail'>
                  <Form.Label>{t('Valid From')}</Form.Label>
                  <Form.Control
                    id='date'
                    type='date'
                    placeholder={t('Valid From')}
                    onChange={(e: any) => setValidFrom(e.target.value)}
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group controlId='formBasicEmail'>
                  <Form.Label>{t('Valid To')}</Form.Label>
                  <Form.Control
                    id='datee'
                    type='date'
                    placeholder={t('Valid To')}
                    onChange={(e: any) => setValidTo(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Form.Group className='w-100 mb-5' controlId='formBasicEmail'>
              <Form.Label>{t('deskrisi')}</Form.Label>
              <FloatingLabel controlId='floatingTextarea' label={t('deskrisi')} className='mb-3'>
                <Form.Control
                  id='desc'
                  as='textarea'
                  placeholder='Leave a comment here'
                  onChange={(e: any) => setDesc(e.target.value)}
                />
              </FloatingLabel>
            </Form.Group>

            <div className='d-flex justify-content-end'>
              {sessionStorage.getItem('jbp') == 'jbp' ? (
                <Link to={'/master/price/jbp'}>
                  <Button variant='secondary' className='me-2'>
                    {t('Back')}
                  </Button>
                </Link>
              ) : (
                <Link to={'/master/price/non-jbp'}>
                  <Button variant='secondary' className='me-2'>
                    {t('Back')}
                  </Button>
                </Link>
              )}
              <Button variant='primary' onClick={postPrice} disabled={btnLoading}>
                {btnLoading ? <Spinner animation='border' variant='light' size='sm' /> : t('buat')}
              </Button>
            </div>
          </div>
        </div>
      </div>

      <ModalBrowseCustomers
        show={show}
        selected={customerCode}
        onClose={handleClose}
        onSelectCustomer={(customerId) => handleCustomer(customerId)}
      />

      <ModalBrowsBasicPrices
        show={show2}
        selected={productCode}
        onClose={handleClose2}
        onSelected={(productId) => handleProduct(productId)}
      />
    </>
  )
}

export {CreateJbp}
